import {
  ShellIconActivity,
  ShellIconArchive,
  ShellIconBarChart,
  ShellIconBell,
  ShellIconBuilding,
  ShellIconCalendar,
  ShellIconCar,
  ShellIconClipboardList,
  ShellIconDollarSign,
  ShellIconHome,
  ShellIconLayers,
  ShellIconLayout,
  ShellIconPackage,
  ShellIconReceipt,
  ShellIconRuler,
  ShellIconSettings,
  ShellIconSparkles,
  ShellIconTag,
  ShellIconUsers,
  ShellIconWarehouse,
  ShellIconWrench,
} from '@zrsystem/ui';

import { appPaths } from '@/app/router/paths.js';
import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

/** Operacional — nível `place`. */
export const PLACE_NAV_ENTRIES: readonly ShellNavEntry[] = [
  {
    kind: 'link',
    id: 'home',
    label: 'Início',
    icon: ShellIconHome,
    path: appPaths.home,
    matchPrefix: appPaths.home,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'appointments',
    label: 'Agenda',
    icon: ShellIconCalendar,
    path: appPaths.appointments,
    matchPrefix: appPaths.appointments,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'yard',
    label: 'Pátio',
    icon: ShellIconWarehouse,
    path: appPaths.yard,
    matchPrefix: appPaths.yard,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'notification-campaigns',
    label: 'Campanhas',
    icon: ShellIconBell,
    path: appPaths.notificationCampaigns,
    matchPrefix: appPaths.notificationCampaigns,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'customers',
    label: 'Clientes',
    icon: ShellIconUsers,
    path: appPaths.customers,
    matchPrefix: appPaths.customers,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'suppliers',
    label: 'Fornecedores',
    icon: ShellIconBuilding,
    path: appPaths.suppliers,
    matchPrefix: appPaths.suppliers,
    enabled: true,
  },
  {
    kind: 'group',
    id: 'catalog',
    label: 'Catálogo',
    icon: ShellIconPackage,
    matchPrefix: appPaths.catalog,
    defaultPath: appPaths.catalogServices,
    children: [
      {
        kind: 'route',
        id: 'catalog-services',
        label: 'Serviços',
        icon: ShellIconWrench,
        path: appPaths.catalogServices,
        matchPrefix: appPaths.catalogServices,
      },
      {
        kind: 'route',
        id: 'catalog-products',
        label: 'Produtos',
        icon: ShellIconArchive,
        path: appPaths.catalogProducts,
        matchPrefix: appPaths.catalogProducts,
      },
      {
        kind: 'route',
        id: 'catalog-kits',
        label: 'Kits',
        icon: ShellIconPackage,
        path: appPaths.catalogKits,
        matchPrefix: appPaths.catalogKits,
      },
      {
        kind: 'route',
        id: 'catalog-useful-life',
        label: 'Vida útil',
        icon: ShellIconActivity,
        path: appPaths.catalogUsefulLife,
        matchPrefix: appPaths.catalogUsefulLife,
      },
      {
        kind: 'route',
        id: 'catalog-revision-plans',
        label: 'Planos de revisão',
        icon: ShellIconClipboardList,
        path: appPaths.catalogRevisionPlans,
        matchPrefix: appPaths.catalogRevisionPlans,
      },
      {
        kind: 'route',
        id: 'catalog-maintenance-checklists',
        label: 'Check-lists de manutenção',
        icon: ShellIconClipboardList,
        path: appPaths.catalogMaintenanceChecklists,
        matchPrefix: appPaths.catalogMaintenanceChecklists,
      },
      {
        kind: 'route',
        id: 'catalog-price-policy',
        label: 'Precificação',
        icon: ShellIconDollarSign,
        path: appPaths.catalogPricePolicy,
        matchPrefix: appPaths.catalogPricePolicy,
      },
      {
        kind: 'route',
        id: 'catalog-price-simulator',
        label: 'Simulador',
        icon: ShellIconBarChart,
        path: appPaths.catalogPriceSimulator,
        matchPrefix: appPaths.catalogPriceSimulator,
      },
      {
        kind: 'route',
        id: 'catalog-price-promotions',
        label: 'Promoções',
        icon: ShellIconSparkles,
        path: appPaths.catalogPricePromotions,
        matchPrefix: appPaths.catalogPricePromotions,
      },
      {
        kind: 'quickPanel',
        id: 'catalog-categories',
        label: 'Categorias',
        icon: ShellIconLayers,
        panelKey: 'catalog-taxonomy-list',
        entity: 'categories',
        title: 'Categorias',
      },
      {
        kind: 'quickPanel',
        id: 'catalog-brands',
        label: 'Marcas',
        icon: ShellIconTag,
        panelKey: 'catalog-taxonomy-list',
        entity: 'brands',
        title: 'Marcas',
      },
      {
        kind: 'quickPanel',
        id: 'catalog-product-types',
        label: 'Tipos de produto',
        icon: ShellIconLayout,
        panelKey: 'catalog-taxonomy-list',
        entity: 'product-types',
        title: 'Tipos de produto',
      },
      {
        kind: 'quickPanel',
        id: 'catalog-service-types',
        label: 'Tipos de serviço',
        icon: ShellIconWrench,
        panelKey: 'catalog-taxonomy-list',
        entity: 'service-types',
        title: 'Tipos de serviço',
      },
      {
        kind: 'quickPanel',
        id: 'catalog-manufacturers',
        label: 'Fabricantes',
        icon: ShellIconBuilding,
        panelKey: 'catalog-taxonomy-list',
        entity: 'manufacturers',
        title: 'Fabricantes',
      },
      {
        kind: 'quickPanel',
        id: 'catalog-measurement-units',
        label: 'Unidades de medida',
        icon: ShellIconRuler,
        panelKey: 'catalog-taxonomy-list',
        entity: 'measurement-units',
        title: 'Unidades de medida',
      },
    ],
  },
  {
    kind: 'link',
    id: 'vehicles',
    label: 'Veículos',
    icon: ShellIconCar,
    path: appPaths.vehicles,
    matchPrefix: appPaths.vehicles,
    enabled: true,
  },
  {
    kind: 'group',
    id: 'inventory',
    label: 'Estoque',
    icon: ShellIconWarehouse,
    matchPrefix: appPaths.inventory,
    defaultPath: appPaths.inventoryStockBalances,
    children: [
      {
        kind: 'route',
        id: 'inventory-stock-balances',
        label: 'Saldo',
        icon: ShellIconArchive,
        path: appPaths.inventoryStockBalances,
        matchPrefix: appPaths.inventoryStockBalances,
      },
      {
        kind: 'route',
        id: 'inventory-stock-movements',
        label: 'Movimentações',
        icon: ShellIconClipboardList,
        path: appPaths.inventoryStockMovements,
        matchPrefix: appPaths.inventoryStockMovements,
      },
      {
        kind: 'route',
        id: 'inventory-stock-transfers',
        label: 'Transferências',
        icon: ShellIconPackage,
        path: appPaths.inventoryStockTransfers,
        matchPrefix: appPaths.inventoryStockTransfers,
      },
      {
        kind: 'route',
        id: 'inventory-stock-inventories',
        label: 'Inventário físico',
        icon: ShellIconRuler,
        path: appPaths.inventoryStockInventories,
        matchPrefix: appPaths.inventoryStockInventories,
      },
      {
        kind: 'route',
        id: 'inventory-inbound-conferences',
        label: 'Conferência de entrada',
        icon: ShellIconReceipt,
        path: appPaths.inventoryInboundConferences,
        matchPrefix: appPaths.inventoryInboundConferences,
      },
    ],
  },
  {
    kind: 'group',
    id: 'purchasing',
    label: 'Compras',
    icon: ShellIconClipboardList,
    matchPrefix: appPaths.purchasing,
    defaultPath: appPaths.purchasingQuotes,
    children: [
      {
        kind: 'route',
        id: 'purchasing-quotes',
        label: 'Cotações',
        icon: ShellIconReceipt,
        path: appPaths.purchasingQuotes,
        matchPrefix: appPaths.purchasingQuotes,
      },
      {
        kind: 'route',
        id: 'purchasing-orders',
        label: 'Pedidos',
        icon: ShellIconPackage,
        path: appPaths.purchasingOrders,
        matchPrefix: appPaths.purchasingOrders,
      },
    ],
  },
  {
    kind: 'group',
    id: 'service-order',
    label: 'Ordens de serviço',
    icon: ShellIconCar,
    matchPrefix: appPaths.serviceOrderCheckIn,
    defaultPath: appPaths.serviceOrderQuotes,
    children: [
      {
        kind: 'route',
        id: 'service-order-check-in',
        label: 'Check-in',
        icon: ShellIconClipboardList,
        path: appPaths.serviceOrderCheckIn,
        matchPrefix: appPaths.serviceOrderCheckIn,
      },
      {
        kind: 'route',
        id: 'service-order-quotes',
        label: 'Orçamentos',
        icon: ShellIconReceipt,
        path: appPaths.serviceOrderQuotes,
        matchPrefix: appPaths.serviceOrderQuotes,
      },
      {
        kind: 'route',
        id: 'service-order-orders',
        label: 'Ordens de serviço',
        icon: ShellIconCar,
        path: appPaths.serviceOrders,
        matchPrefix: appPaths.serviceOrders,
      },
      {
        kind: 'route',
        id: 'service-order-realized-margin',
        label: 'Margem realizada',
        icon: ShellIconBarChart,
        path: appPaths.serviceOrderRealizedMargin,
        matchPrefix: appPaths.serviceOrderRealizedMargin,
      },
      {
        kind: 'route',
        id: 'service-order-break-even',
        label: 'Ponto de equilíbrio',
        icon: ShellIconBarChart,
        path: appPaths.serviceOrderBreakEven,
        matchPrefix: appPaths.serviceOrderBreakEven,
      },
      {
        kind: 'route',
        id: 'service-order-productivity',
        label: 'Produtividade',
        icon: ShellIconBarChart,
        path: appPaths.serviceOrderProductivity,
        matchPrefix: appPaths.serviceOrderProductivity,
      },
      {
        kind: 'route',
        id: 'service-order-check-out',
        label: 'Check-out',
        icon: ShellIconReceipt,
        path: appPaths.serviceOrderCheckOut,
        matchPrefix: appPaths.serviceOrderCheckOut,
      },
    ],
  },
  {
    kind: 'group',
    id: 'financeiro',
    label: 'Financeiro',
    icon: ShellIconDollarSign,
    matchPrefix: '/financeiro',
    defaultPath: appPaths.caixa,
    children: [
      {
        kind: 'route',
        id: 'finance-caixa',
        label: 'Caixa',
        icon: ShellIconDollarSign,
        path: appPaths.caixa,
        matchPrefix: appPaths.caixa,
      },
      {
        kind: 'route',
        id: 'finance-accounts-receivable',
        label: 'Contas a receber',
        icon: ShellIconReceipt,
        path: appPaths.financeAccountsReceivable,
        matchPrefix: appPaths.financeAccountsReceivable,
      },
      {
        kind: 'route',
        id: 'finance-collection-charges',
        label: 'Cobranças CNAB',
        icon: ShellIconReceipt,
        path: appPaths.financeCollectionCharges,
        matchPrefix: appPaths.financeCollectionCharges,
      },
      {
        kind: 'route',
        id: 'finance-bank-reconciliation',
        label: 'Conciliação',
        icon: ShellIconBarChart,
        path: appPaths.financeBankReconciliation,
        matchPrefix: appPaths.financeBankReconciliation,
      },
      {
        kind: 'route',
        id: 'finance-accounts-payable',
        label: 'Contas a pagar',
        icon: ShellIconDollarSign,
        path: appPaths.financeAccountsPayable,
        matchPrefix: appPaths.financeAccountsPayable,
      },
      {
        kind: 'route',
        id: 'finance-cash-flow',
        label: 'Fluxo de caixa',
        icon: ShellIconBarChart,
        path: appPaths.financeCashFlow,
        matchPrefix: appPaths.financeCashFlow,
      },
      {
        kind: 'route',
        id: 'finance-income-statement',
        label: 'DRE',
        icon: ShellIconBarChart,
        path: appPaths.financeIncomeStatement,
        matchPrefix: appPaths.financeIncomeStatement,
      },
      {
        kind: 'route',
        id: 'finance-chart-of-accounts',
        label: 'Plano de contas',
        icon: ShellIconLayers,
        path: appPaths.financeChartOfAccounts,
        matchPrefix: appPaths.financeChartOfAccounts,
      },
      {
        kind: 'route',
        id: 'finance-payment-settings',
        label: 'Parametrização',
        icon: ShellIconSettings,
        path: appPaths.financePaymentSettings,
        matchPrefix: appPaths.financePaymentSettings,
      },
    ],
  },
  {
    kind: 'group',
    id: 'fiscal',
    label: 'Fiscal',
    icon: ShellIconReceipt,
    matchPrefix: '/fiscal',
    defaultPath: appPaths.fiscalDocumentos,
    children: [
      {
        kind: 'route',
        id: 'fiscal-documents',
        label: 'Documentos fiscais',
        icon: ShellIconReceipt,
        path: appPaths.fiscalDocumentos,
        matchPrefix: appPaths.fiscalDocumentos,
      },
      {
        kind: 'route',
        id: 'fiscal-dfe-inbox',
        label: 'Caixa de entrada',
        icon: ShellIconReceipt,
        path: appPaths.fiscalDfeInbox,
        matchPrefix: appPaths.fiscalDfeInbox,
        enabled: true,
      },
      {
        kind: 'route',
        id: 'fiscal-apuracao',
        label: 'Apuração',
        icon: ShellIconBarChart,
        path: appPaths.fiscalApuracao,
        matchPrefix: appPaths.fiscalApuracao,
        enabled: false,
      },
      {
        kind: 'route',
        id: 'fiscal-ncm',
        label: 'NCMs',
        icon: ShellIconTag,
        path: appPaths.fiscalNcm,
        matchPrefix: appPaths.fiscalNcm,
        enabled: true,
      },
      {
        kind: 'route',
        id: 'fiscal-parametrizacao',
        label: 'Parametrização',
        icon: ShellIconSettings,
        path: appPaths.fiscalParametrizacao,
        matchPrefix: appPaths.fiscalParametrizacao,
      },
    ],
  },
  {
    kind: 'link',
    id: 'geo-cities',
    label: 'Cidades',
    icon: ShellIconBuilding,
    path: appPaths.geoCities,
    matchPrefix: appPaths.geoCities,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'reports',
    label: 'Relatórios',
    icon: ShellIconBarChart,
    enabled: false,
  },
] as const;
